// The waiting state. aria-live so a screen reader hears that a reply is coming
// rather than sitting in silence; the dots themselves are decorative.

export function Typing() {
  return (
    <div className="row">
      <div className="typing" role="status" aria-live="polite" aria-label="Thinking">
        <i aria-hidden="true" />
        <i aria-hidden="true" />
        <i aria-hidden="true" />
      </div>
    </div>
  );
}
